import React from 'react'
import ChartFlexSection from '@components/chart/ChartFlexSection'
import { IResponseOptProjectEvaluationSummary, IResponseOptProjectEvaluationSummaryRow } from '@interfaces/api/IDashboard'
import TextChartTitle from '@components/text/TextChartTitle'
import { Money, ThY } from '@utils/utils'
import Chart from 'react-google-charts'
import { ColumnChartOptions } from '@components/chart/setting'

const ProjectEvaluationSummary = ({ title, data }: { title: string; data: IResponseOptProjectEvaluationSummary }) => {
  const chartData = [
    [
      'ปีงบประมาณ',
      'ด้านคุณภาพการให้บริการ',
      { role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
      'ด้านกระบวนการ ขั้นตอนการให้บริการ ',
      { role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
      'ด้านเจ้าหน้าที่ผู้ให้บริการ',
      { role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
      'ด้านสิ่งอำนวยความสะดวก',
      { role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
      'ผลประเมินโดยรวม',
      { role: 'annotation' },
      { role: 'tooltip', type: 'string', p: { html: true } },
    ],
    ...data.map((item) => {
      const row: (string | number)[] = [
        String(ThY(item.budget_year)) + `\n (ผลประเมิน ${item.total_evaluation_projects} โครงการ จาก ${item.total_projects} โครงการ)`,
      ]
      const factors: Partial<Record<keyof IResponseOptProjectEvaluationSummaryRow, string>> = {
        avg_project_evaluation_quality_result: 'คุณภาพการให้บริการ',
        avg_project_evaluation_process_result: 'กระบวนการ ขั้นตอนการให้บริการ',
        avg_project_evaluation_personnel_result: 'เจ้าหน้าที่ผู้ให้บริการ',
        avg_project_evaluation_facility_result: 'สิ่งอำนวยความสะดวก',
        avg_project_evaluation_result: 'ผลประเมินโดยรวม',
      }

      ;(Object.keys(factors) as (keyof IResponseOptProjectEvaluationSummaryRow)[]).forEach((factor) => {
        row.push(parseFloat(String(item[factor])))
        row.push(Money(item[factor]))
        row.push(`<div style="padding:8px; width: 280px">
            <strong>ปีงบประมาณ ${ThY(item.budget_year)}</strong><br/>
            <strong>${factors[factor]}</strong><br/>
            ผลการประเมิน : ${Money(item[factor])}<br/>
          </div>
        `)
      })

      return row
    }),
  ]
  const options = ColumnChartOptions('ผลประเมินความพึงพอใจโครงการ', 'ค่าเฉลี่ยผลการประเมิลความพึงพอใจ 4 ด้าน และผลรวม')

  return (
    <ChartFlexSection className="pagebreak">
      <TextChartTitle>{title}</TextChartTitle>
      <Chart width={'100%'} height={'500px'} chartType="ColumnChart" loader={<div>Loading Chart</div>} data={chartData} options={options} />
    </ChartFlexSection>
  )
}

export default ProjectEvaluationSummary
